import * as React from 'react'
import { reduxForm, InjectedFormProps, formValueSelector } from 'redux-form'
import { FormGroup, Button, Alert } from 'react-bootstrap'
import { connect } from 'react-redux'

import { FORM_CREATE_USER } from '../../constants/Form'
import {
  CREATE_USER_FORM_EMAIL,
  CREATE_USER_FORM_NAME,
  CREATE_USER_FORM_ADMIN,
  CREATE_USER_FORM_IS_PASSIVE
} from '../../constants/CreateUserFormFieldName'
import { InputControlField } from '../../components/form/InputControl'
import { CheckboxControlField } from '../../components/form/CheckboxControl'
import { StoreState } from '../../reducers'
import { isEmail, isRequired } from '../../utils/validators'
import { ApolloError } from 'apollo-client'
import { GetProps } from '../../types'

export interface CreateUserFormData {
  email: string
  name: string
  admin: boolean
  isPassive: boolean
}

interface CreateUserFormOwnProps {
  isPassive: boolean
  formError?: ApolloError
}

export type CreateUserFormProps = InjectedFormProps<
  CreateUserFormData,
  CreateUserFormOwnProps
> &
  CreateUserFormOwnProps

const CreateUserForm: React.SFC<CreateUserFormProps> = ({
  handleSubmit,
  isPassive,
  formError
}) => {
  if (formError) {
    console.log(
      formError,
      formError.extraInfo,
      formError.graphQLErrors,
      formError.networkError
    )

    console.log(formError.extraInfo)
  }

  return (
    <form onSubmit={handleSubmit}>
      {!isPassive && (
        <InputControlField
          label="Email"
          name={CREATE_USER_FORM_EMAIL}
          type="text"
          placeholder="Email"
          validate={[isRequired, isEmail]}
        />
      )}
      <InputControlField
        label="Jméno"
        name={CREATE_USER_FORM_NAME}
        type="text"
        placeholder="Nickname"
        validate={isRequired}
      />
      <CheckboxControlField name={CREATE_USER_FORM_ADMIN} label="Admin?" />
      <CheckboxControlField
        name={CREATE_USER_FORM_IS_PASSIVE}
        label="Pasivní uživatel"
      />
      <FormGroup>
        <Button bsStyle="primary" type="submit">
          Vytvořit uživatele
        </Button>
      </FormGroup>
      <FormGroup>
        {formError && (
          <Alert bsStyle="danger">
            {formError.graphQLErrors.map(({ message }) => message).join(', ')}
          </Alert>
        )}
      </FormGroup>
    </form>
  )
}

const formSelector = formValueSelector(FORM_CREATE_USER)

const connector = connect((state: StoreState) => {
  const isPassive = formSelector(state, CREATE_USER_FORM_IS_PASSIVE)

  return {
    isPassive
  }
})

const Form = reduxForm<CreateUserFormData, CreateUserFormOwnProps>({
  form: FORM_CREATE_USER,
  initialValues: {
    admin: true,
    isPassive: false
  }
})(CreateUserForm)

type FormProps = GetProps<typeof Form>

const Wrapper: React.SFC<FormProps> = ({ ...props }) => {
  return <Form {...props} />
}

export default connector(Wrapper)



// WEBPACK FOOTER //
// ./src/screens/createUser/CreateUserForm.tsx